import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "Icon",
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M13.393 2.375H1.607c-.592 0-1.071.48-1.071 1.071v9.108c0 .591.48 1.071 1.071 1.071h11.786c.592 0 1.071-.48 1.071-1.071V3.446c0-.591-.48-1.071-1.071-1.071Z\" stroke=\"currentColor\"></path><path d=\"m.536 3.714 6.278 5.357a1.071 1.071 0 0 0 1.372 0l6.278-5.357\" stroke=\"#007F8F\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" transform=\"translate(0 .5)\" d=\"M0 0h15v15H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }